// extracted by mini-css-extract-plugin
export default {"page-data-loading":"PageDataLoading_page-data-loading__DSxbD"};